/**
 * Starter suggestions for the RoutineBuilder empty state (P12 §6.5).
 *
 * Unlike the dashboard assistant (which derives prompts from an existing dashboard's panels), a
 * routine is built from scratch, so the suggestions are generic "describe the routine you want"
 * starters that seed the warehouse-query → optional-condition → Slack-message flow.
 */
export interface RoutinePrompt {
  label: string;
  prompt: string;
}

export const ROUTINE_STARTER_PROMPTS: readonly RoutinePrompt[] = [
  {
    label: 'Daily signups digest',
    prompt: 'Build a routine that posts the number of new signups in the last day to a Slack channel every morning.',
  },
  {
    label: 'Alert on a spike',
    prompt: 'Alert a Slack channel when error events in the last hour go above a threshold.',
  },
  {
    label: 'Weekly summary',
    prompt: 'Send a weekly summary of top events by volume to Slack every Monday at 9am.',
  },
];
